import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, Optional, Inject } from '@angular/core';
import { TradingEntitlements } from '../../models/common/trading-entitlements';
import { Account, Quote, TradingOrderBase } from '../../models/common/trading-common.model';
import { TradingService } from '../../services/common/trading-service.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MutualFundDetail } from './../../models/mutualfund/trading-mutualfund.model';
import { MatDialog } from '@angular/material/dialog';
import { QuoteMobileDialog } from './quote-dialog.component';
import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
@Component({
  selector: 'quote-mini',
  templateUrl: './quote-mini.component.html',
  styleUrls: ['./quote-mini.component.css']
})
export class QuoteMiniComponent implements OnInit, OnDestroy {
  @Output() quoteRefreshRequestedEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() openDialogEmitter = new EventEmitter<string>();
  @Input() order: any;
  @Input() tradingEntitlements: TradingEntitlements;
  @Input() templateType: string = 'mobile';
  @Input() quoteCategory: string;
  @Input() activeTheme: string;
  @Input() platform: string;
  @Input() account: Account;

  quote: Quote;
  fundDetails: MutualFundDetail;
  isRealTimeChecked: boolean = false;
  isNonDollar: boolean = false;
  showRealTime: boolean = false;
  showSpin: boolean = false;
  isExtendedHours: boolean = false;
  isHolidayWeekendHours: boolean = false;
  showQuote: boolean = false;
  isEquity: boolean = false;
  isMutualFund: boolean = false;
  isMutualFundExchange: boolean = false;
  isOptionUnderlyingSymbol: boolean = false;
  isOption: boolean = false;
  quoteType: string;
  flagClassName = '';
  dollarSymbol: string = '$';
  crossMark: string = ' x ';

  quoteSubscription: Subscription;
  language: string = '';
  formatLocale: string = '';


  constructor(private tradingService: TradingService,
    public dialog: MatDialog, @Optional() @Inject('AppSettings') appSettings: any) { 
      if (appSettings?.language) {
        this.language = appSettings.language;
        if (this.language === 'es') {
           this.formatLocale = 'es';
           registerLocaleData( es );
        }
    }
    }

  ngOnInit() {
    let quoteSubject$: BehaviorSubject<TradingOrderBase>;
    if (this.quoteCategory === 'MutualFundExchange') {
      quoteSubject$ = this.tradingService.secondQuoteSubject$;
    } else {
      quoteSubject$ = this.tradingService.quoteSubject$;
    }
    this.showQuote = false;
    this.quoteSubscription = quoteSubject$.subscribe(
      (success: TradingOrderBase) => this.quoteSuccessCallback(success),
      (error) => this.quoteErrorCallback(error));

    this.showRealTimeCheckBox();
  }

  quoteSuccessCallback(order: TradingOrderBase): void {
    if (!order) {
      this.showQuote = false;
      return;
    }
    if (this.quoteCategory === 'Equity') {
        this.quote = this.order.quote;
    } else if (this.quoteCategory === 'MutualFund') {
        this.quote = this.order.quote;
        this.fundDetails = this.order.mutualFund;
    } else if (this.quoteCategory === 'MutualFundExchange') {
        this.quote = this.order.exchangeQuote;
        this.fundDetails = this.order.exchangeMutualFund;
    } else if (this.quoteCategory === 'OptionUnderlyingSymbol') {
        this.quote = this.order.underlyingSymbolQuote;
    } else if (this.quoteCategory === 'Option') {
        this.quote = this.order.quote;
    }

    if (!!this.quote) {
      if (this.quoteCategory === 'Equity') {
        this.isEquity = true;
        this.quote = this.order.quote;
      } else if (this.quoteCategory === 'MutualFund') {
        this.isMutualFund = true;
        this.quote = this.order.quote;
      } else if (this.quoteCategory === 'MutualFundExchange') {
        this.isMutualFundExchange = true;
        this.quote = this.order.exchangeQuote;
      } else if (this.quoteCategory === 'OptionUnderlyingSymbol') {
        this.isOptionUnderlyingSymbol = true;
        this.quote = this.order.underlyingSymbolQuote;
      } else if (this.quoteCategory === 'Option') {
        this.isOption = true;
        this.quote = this.order.quote;
      }
      this.getCurrencyFlag();
      this.showSpin = false;
      this.showQuote = true;
    } else {
      this.showSpin = false;
      this.showQuote = false;
    }
  }

  quoteErrorCallback(error) {
    this.showSpin = false;
    this.showQuote = false;
    console.log('QuoteMiniComponent - quoteErrorCallback: ', error);
  }

  showRealTimeCheckBox(): void {
    // User entitlement will always have isUnlimitedRTQuotesEnabled:true per new requirement
    // But for non-dollar quote is not realtime - use this.isRealTimeChecked to show delayed disclaimer
    if (this.isNonDollar || (this.tradingEntitlements.isRetailUser && !this.tradingEntitlements.isExchangeAgreementSignedByUser)) {
      this.isRealTimeChecked = false;
      this.quoteType = 'DELAYED';
    } else {
      this.isRealTimeChecked = true;
      this.quoteType = 'REALTIME';
    }
    this.showRealTime = false;

    // **** Clean up following code later just in case we want to revert back the logic ****
    // if (!this.isExtendedHours && !this.isHolidayWeekendHours) {
    //     if (this.tradingEntitlements.isRTQuotesEnabled) {
    //         this.showRealTime = true;
    //         this.isRealTimeChecked = false;
    //     } else {
    //         this.showRealTime = false;
    //         this.isRealTimeChecked = false;
    //     }
    //     if (this.tradingEntitlements.isUnlimitedRTQuotesEnabled) {
    //         this.showRealTime = false;
    //         this.isRealTimeChecked = true;
    //         this.quoteType = 'REALTIME';
    //     }
    // } else {
    //     this.showRealTime = false;
    //     this.isRealTimeChecked = false;
    // }
}

getCurrencyFlag() {
  if (this.quote.qtIntlInd !== null && this.quote.qtIntlInd === 'Y') {
    this.isNonDollar = true;
  } else {
    this.isNonDollar = false;
  }

  let countryCD = (this.quote.qtCurrencyCd || '').trim().substring(0, 2).toLowerCase() || 'us';
  const classPrefix = 'flag-icon-';
  if (!!this.quote.symId) {
      const ccySuffix: string[] = this.quote.symId.trim().toLowerCase().split(':');
      if (ccySuffix.length > 1 && ccySuffix[1].length > 0) {
          countryCD = ccySuffix[1];
      }
  }
  this.flagClassName =  classPrefix + countryCD;
}

  refreshQuote(): void {
    this.quoteType = this.isRealTimeChecked ? 'REALTIME' : 'DELAYED';
    this.showSpin = true;
    this.quoteRefreshRequestedEmitter.emit({
      quoteType: this.quoteType,
      quoteCategory: this.quoteCategory
    });
  }

  openDialog(): void {
  const quoteDialogRef = this.dialog.open(QuoteMobileDialog, {
    panelClass: 'modal',
    width: '300px',
    disableClose: true,
    autoFocus: false,
    data: {
        platform: this.platform,
        tradingEntitlements: this.tradingEntitlements,
        activeTheme: this.activeTheme,
        account: this.account,
        order: this.order,
        symbolStr: this.quote.symId,
        isNonDollarCCY: this.isNonDollar,
        quoteCategory: this.quoteCategory
    }
});
}

  ngOnDestroy(): void {
    if ( !!this.quoteSubscription ) {
      this.quoteSubscription.unsubscribe();
    }
  }
}
